import React from "react";
import Select, { components as SelectComponents } from "react-select";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";


const CountryOption = (props) => {
    const iso2 = props.data.iso2;
    const Flag = flags[iso2];
    return (
        <SelectComponents.Option {...props}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                {Flag ? React.createElement(Flag, { style: { width: 20, height: 14 } }) : null}
                <span>{props.data.label}</span>
            </span>
        </SelectComponents.Option>
    );
};

const CountrySingleValue = (props) => {
    const iso2 = props.data.iso2;
    const Flag = flags[iso2];
    return (
        <SelectComponents.SingleValue {...props}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                {Flag ? React.createElement(Flag, { style: { width: 20, height: 14 } }) : null}
                <span>{props.data.label}</span>
            </span>
        </SelectComponents.SingleValue>
    );
};

export default function CountryDialCodeSelect({ valueISO2 = "BR", onChange, styles, width = "auto" }) {
    const allCountries = getCountries(); 
    const options = allCountries.map((c) => ({
        value: c,
        label: `+${getCountryCallingCode(c)} ${c}`,
        ddi: `+${getCountryCallingCode(c)}`,
        iso2: c,
    }));

    const current = valueISO2 ? {
        value: valueISO2,
        label: `+${getCountryCallingCode(valueISO2)} ${valueISO2}`,
        ddi: `+${getCountryCallingCode(valueISO2)}`,
        iso2: valueISO2,
    } : null;

    const handleChange = (opt) => {
        if (!opt) return;
        const dialCode = `+${getCountryCallingCode(opt.iso2)}`;
        if (onChange) {
            onChange({ dialCode, iso2: opt.iso2 });
        }
    };

    return (
        <div style={{ width }}>
            <Select
                value={current}
                onChange={handleChange}
                options={options}
                isSearchable={false}
                components={{ Option: CountryOption, SingleValue: CountrySingleValue }}
                styles={{
                    control: (base) => ({ ...base, minHeight: 40, borderRadius: 4 }),
                    valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    ...styles,
                }}
            />
        </div>
    );
}


